"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LotStatusTag = void 0;
var react_1 = __importDefault(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var LotStatusTag = function (props) {
    var auctionStatus = props.auctionStatus, lotStatus = props.lotStatus, size = props.size;
    function determineColors(auctionStatus, lotStatus) {
        if (auctionStatus == "Upcoming") {
            return {
                backgroundColor: "bg-secondary",
                valueColor: "text-white",
            };
        }
        console.log("lotStatus", lotStatus);
        switch (lotStatus) {
            case "Sold":
                return {
                    backgroundColor: "bg-green-500",
                    valueColor: "text-white",
                };
            case "Bidding Closed":
                return {
                    backgroundColor: "bg-blue-400",
                    valueColor: "text-white",
                };
            case "Bidding Open":
                return {
                    backgroundColor: "bg-orange-400",
                    valueColor: "text-white",
                };
            case "Withdrawn":
                return {
                    backgroundColor: "bg-error",
                    valueColor: "text-white",
                };
            default:
                return {
                    backgroundColor: "bg-secondary",
                    valueColor: "text-white",
                };
        }
    }
    return react_1.default.createElement(doshx_controls_web_1.BadgeControl, { value: auctionStatus == "Upcoming" ? auctionStatus : lotStatus, size: size, colors: determineColors(auctionStatus, lotStatus) });
};
exports.LotStatusTag = LotStatusTag;
